"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utility for setting a property deep on an object using
 * a keyPath array ['pageInfo', 'pageName'] etc
 */
function setDeepValue(targetObject, keyPath, value) {
    for (var i = 0; i < keyPath.length; i++) {
        // Traverse the keyPath deeper and deeper :D
        if (i < keyPath.length - 1) {
            targetObject = targetObject[keyPath[i]];
        }
        else if (targetObject[keyPath[i]] !== value) {
            // Only update is value has changed.
            targetObject[keyPath[i]] = value;
            return true;
        }
    }
    return false;
}
exports.setDeepValue = setDeepValue;
